import UnAuthorizedLayout from "../../../../branchAndBrandSpecific/layout/UnAuthorizedLayout";
import { FC, useEffect } from "react";
import { AuthCard } from "./../components/AuthCard";
import { AuthenticationProps } from "../types/authenticationTypes";
import { brand } from "../../../../branchAndBrandSpecific/utils/brandVariables/brandVariables";
import { useNavigate } from "react-router-dom";
import useDocumentTitle from "@/hooks/useDocumentTitle";
import i18next from "i18next";
import { AuthCodeForm } from "@/components/AuthCodeInputForm/AuthCodeForm";
import { useVerificationCode } from "../hooks/useVerificationCode";

export const VerifyEmail: FC = (): JSX.Element => {
  const navigate = useNavigate();

  // Check if email exists in local storage
  useEffect(() => {
    if (!localStorage.getItem("authEmailLocal")) {
      navigate("/signup");
    }
  }, [navigate]);

  const baseAuthenticationProps = {
    method: "email",
    emailAddress: localStorage.getItem("authEmailLocal"),
    platform: brand.brandValue,
    tenantId: brand.tenantId,
  } as AuthenticationProps;

  const { code, setCode, setFieldValue, loading, resendCode, response } =
    useVerificationCode({
      baseAuthenticationProps,
      action: "verify-email",
      onSuccess: (response) => {
        if (response.redirectURL) {
          navigate(response.redirectURL);
        }
      },
    });

  // Page Document Title
  useDocumentTitle(i18next.t("auth.verify.headline"));

  if (!localStorage.getItem("authEmailLocal")) {
    return null; // Return null since we're navigating away
  }

  return (
    <UnAuthorizedLayout>
      <AuthCard title={i18next.t("auth.verify.headline")} type="verify-email">
        <AuthCodeForm
          requestFunction={resendCode}
          loading={loading}
          code={code}
          setFieldValue={setFieldValue}
        />
      </AuthCard>
    </UnAuthorizedLayout>
  );
};
